<template>
  <div class="forgotPass">
    <p class="title">Wachtwoord vergeten</p>
    <form class="forgotPassForm" @submit.prevent="forgotPasswordClick">
      <div class="column">
        <div class="form-group">
          <label for="email">{{ $t("components.email") }}<span>*</span></label>
          <!-- v-validate="{ required: true }" -->
          <input
            type="email"
            v-model="username"
            @change="resetValidation()"
            name="email"
            class="form-control"
            :class="[
              {
                'is-invalid':
                  (submitted && errors.has('email')) ||
                  (error && forgotPassword !== null),
              },
              { 'is-valid': forgotPassword === null },
            ]"
          />
          <!-- display feedback if input is invalid -->
          <div v-if="submitted && errors.has('email')" class="invalid-feedback">
            {{ errors.first("email") }}
          </div>
          <!-- display feedback based on api response  -->
          <div v-else-if="submitted && !errors.has('email')">
            <div v-if="error && forgotPassword !== ''" class="invalid-feedback">
              {{ $t("components.forgotPassword.fail") }}
            </div>
            <div v-else-if="forgotPassword === ''" class="valid-feedback">
              {{ $t("components.forgotPassword.success") }}
            </div>
          </div>
        </div>
      </div>
      <div class="buttonSection">
        <div class="form-group">
          <button type="submit" class="btn">
            {{ $t("components.verzend") }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
// import { mapMutations, mapState } from "vuex";

// export default {
//   data() {
//     return {
//       submitted: false,
//       username: "",
//       error: false,
//     };
//   },
//   watch: {
//     $route: function (params) {
//       if (params.query.error === "404") {
//         this.error = true;
//       }
//     },
//   },
//   methods: {
//     resetValidation() {
//       this.error = false;
//       this.newPassword("");
//       this.$router.replace({ query: "" }).catch((err) => {});
//     },
//     validationSet() {
//       const rules = {
//         email: {
//           rule: {
//             required: true,
//             email: true,
//           },
//           value: this.username,
//         },
//       };

//       return rules;
//     },
//     forgotPasswordClick() {
//       this.resetValidation();
//       this.submitted = true;

//       if (this.validation(this.validationSet())) {
//         this.$emit("newPassword", { username: this.username });
//       }
//     },
//     ...mapMutations("auth", ["newPassword"]),
//   },
//   computed: {
//     ...mapState("auth", ["forgotPassword"]),
//   },
// };

import { ref, computed, watch, getCurrentInstance } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";

export default {
  emit: ["newPassword"],
  setup(_, { emit }) {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();

    // Access Global Validation
    const instance = getCurrentInstance();
    const validation = instance.appContext.config.globalProperties.validation;

    const submitted = ref(false);
    const username = ref("");
    const error = ref(false);

    const forgotPassword = computed(() => store.state.auth.forgotPassword);
    const newPassword = store.commit.bind(store, "auth/newPassword");

    watch(route, (params) => {
      if (params.query.error === "404") {
        error.value = true;
      }
    });

    const resetValidation = () => {
      error.value = false;
      newPassword("");
      router.replace({ query: "" }).catch(() => {});
    };

    const validationSet = () => {
      return {
        email: {
          rule: {
            required: true,
            email: true,
          },
          value: username.value,
        },
      };
    };

    const forgotPasswordClick = () => {
      resetValidation();
      submitted.value = true;

      if (validation(validationSet())) {
        // Emit an event with the new password
        emit("newPassword", { username: username.value });
      }
    };

    return {
      submitted,
      username,
      error,
      forgotPassword,
      resetValidation,
      validationSet,
      forgotPasswordClick,
      newPassword,
    };
  },
};
</script>

<style lang="sass" scoped>
.forgotPass
  display: flex
  height: 100%
  flex-direction: column
  .title
    font-size: 28px
    line-height: 45px
    font-weight: 300
    margin: 0
    margin-bottom: 20px
    text-align: center
  .forgotPassForm
    justify-content: center
    width: 100%
    height: 100%
    overflow-y: auto
    overflow: -moz-scrollbars-none
    -ms-overflow-style: none
    &::-webkit-scrollbar
      width: 0 !important
    .column
      display: flex
      justify-content: space-between
      flex-direction: column
      .form-group
        display: flex
        flex-direction: column
        width: 100%
        margin-bottom: 15px
        &:focus-within
          color: #104E8A
        label
          margin-bottom: 10px
          span
            color: $red
        input
          padding: 5px
          font-size: 15px
          line-height: 24px
          font-family: Ubuntu
          border: none
          border-bottom: 1px solid $grey
          &:focus
            color: #104E8A
            border-bottom: 1px solid #104E8A
            outline: none
        .invalid-feedback
          color: $red
          font-size: 0.8em
        .is-invalid
          border: 1px solid $red
        .valid-feedback
          color: $success
          font-size: 0.8em
        .is-valid
          border: 1px solid $success
    .buttonSection
      .form-group
        display: flex
        width: 100%
        justify-content: space-around
        a
          text-decoration: none
        .btn
          border: none
          height: 45px
          width: 100%
          display: flex
          -webkit-box-align: center
          -ms-flex-align: center
          align-items: center
          justify-content: center
          font-weight: 500
          font-size: 15px
          line-height: 24px
          text-align: center
          border-radius: 22.5px
          background-color: $red
          color: $white
          transition: background-color 300ms ease
          margin-top: 10px
          &:hover
            background-color: #CA3233
</style>
